//个人中心 -- 帐号信息 -- 社交通讯
export const accountInfo = {
  social: {
    'email': 0,
    'phone': 1,
    'wechat': 2,
    'weibo': 3
  }
}

//个人中心 -- 帐号信息 -- 个人资料
export const genderMap = {
  0: 'male',
  1: 'female'
}

//个人中心 -- 帐号信息 -- 登录日志
export const logMap = {
  0: 'default',
  1: 'qq',
  2: 'wechat',
  3: 'weibo'
}

/*
 ** 邮箱验证
 */
export const validateEmail = (str) => {
  let reg = /^[a-zA-Z0-9]+([\.\_\-]*[a-zA-Z0-9]+)*@([a-zA-Z0-9\.\_\-]+\.)+[a-zA-Z0-9]+$/,
      value = str.trim();

  if(value){
    if(!reg.test(value)){  //存在但不符合要求
      return false;
    }
    else{
      return true;
    }
  }
  else{
    return false;
  }
}

/*
 ** 输入是否为空验证
 */
export const validateEmpty = (str) => {
  let value = str.trim();

  if(value){
    return true;
  }
  else{
    return false;
  }
}

/*
 ** 验证手机号
 */
export const validatePhone = (str) => {
  const reg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
  let num = Number(str.trim());
  if(!isNaN(num)){
    if(reg.test(num)){
      return true;
    }

    return false;
  }
}

/*
 ** 验证姓名
 */
export const validateName = (str) => {
 let reg = /^([a-zA-Z0-9\u4e00-\u9fa5\·]{1,10})$/,
     value = str.trim();

 if(value){
   if(!reg.test(value)){  //存在但不符合要求
     return false;
   }
   else{
     return true;
   }
 }
 else{
   return false;
 }
}

/*
 ** 验证身份证号
 */
export const validateIdCard = (str) => {
  const reg = /(^\d{15}$)|(^\d{17}[0-9X]$)/
  if(str){
    if(reg.test(str)){
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/js/config.js